var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.707 7.707C14.8944 7.51947 14.9998 7.26516 14.9998 7C14.9998 6.73484 14.8944 6.48053 14.707 6.293L10.707 2.293C10.5194 2.10553 10.2651 2.00021 9.99997 2.00021C9.7348 2.00021 9.4805 2.10553 9.29297 2.293L5.29297 6.293C5.11081 6.4816 5.01002 6.7342 5.0123 6.9964C5.01457 7.2586 5.11974 7.50941 5.30515 7.69482C5.49056 7.88023 5.74137 7.9854 6.00357 7.98767C6.26576 7.98995 6.51837 7.88916 6.70697 7.707L8.99997 5.414L8.99997 17C8.99997 17.2652 9.10533 17.5196 9.29286 17.7071C9.4804 17.8946 9.73475 18 9.99997 18C10.2652 18 10.5195 17.8946 10.7071 17.7071C10.8946 17.5196 11 17.2652 11 17L11 5.414L13.293 7.707C13.4805 7.89447 13.7348 7.99979 14 7.99979C14.2651 7.99979 14.5194 7.89447 14.707 7.707Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.5e596efa0ea5712581509d411b5db388.svg";
export { ForwardRef as ReactComponent };